import styled from '@emotion/styled';
import { Box } from '@podiumhq/design-system';

export const WiggleAnimation = ({ children, ...props }) => (
  <WiggleAnimationStyled {...props}>{children}</WiggleAnimationStyled>
);

const WiggleAnimationStyled = styled(Box)`
  animation: wiggleWiggle 0.25s ease-in-out;

  @keyframes wiggleWiggle {
    0% {
      transform: translateX(24px);
      opacity: 0;
    }
    50% {
      transform: translateX(-10px);
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;
